import selfInstantiateOnLoad from "../utilities/instantiateUtility";
const dWindow = window;
const couponModalFormElementId = "its-lit-coupon-modal-form";
const couponModalSubmitButtonQuery = `#${couponModalFormElementId} button[name='Submit']`;
const couponErrorElementId = "its-lit-coupon-modal-error-message";
class FireplaceCouponModal {
    constructor() {
        this._config = null;
        this._setupCouponSubmissionMethod = () => {
            const config = this._config;
            //there's definitely a better way to do this. i can't figure out what it is.
            window.fireplaceCouponFormModalConfig = config;
            dWindow.DealeronLead.addSubmissionMethod("sendFireplaceModalSubmit", {
                leadSource: config.source,
                leadType: config.type,
                additionalData: this._getCouponFormComments,
                preSubmit: this._presubmit,
                successCallback: this._onSuccess,
                errorCallback: this._onError,
            });
            dWindow.DealeronLead.initialize("#" + couponModalFormElementId, "sendFireplaceModalSubmit");
            const firstInput = this._formElement.querySelector("input:not([type='hidden'])");
            firstInput.addEventListener("focus", () => {
                if (dWindow.DealeronLead.token.shouldRefresh()) {
                    dWindow.DealeronLead.begin();
                }
            }, { once: true });
        };
        this._formElement = document.getElementById(couponModalFormElementId);
        this._loadConfig();
    }
    _loadConfig() {
        const scriptElement = document.getElementById("fireplace-coupon-lead-config");
        if (scriptElement) {
            this._config = JSON.parse(scriptElement.text);
            this._attachEvents();
        }
        else {
            console.error("#fireplace-coupon-lead-config does not exist. Failed to initialize CouponWidget");
        }
    }
    _attachEvents() {
        window.SetupCouponModal = (offerButton) => {
            const idElement = document.getElementById("its-lit-coupon-campaign-id");
            if (idElement) {
                idElement.textContent = offerButton.getAttribute("data-coupon-campaign");
            }
            const headerTitleElement = document.getElementById("its-lit-coupon-modal-header-title");
            if (headerTitleElement) {
                headerTitleElement.innerHTML = "";
            }
            const titleElement = document.getElementById("its-lit-coupon-modal-title");
            if (titleElement) {
                titleElement.textContent = offerButton.getAttribute("data-form-title");
            }
            this._setupCouponSubmissionMethod();
        };
    }
    _getCouponFormComments() {
        let comment = "";
        const commentElement = document.getElementById("contactus-comments");
        if (commentElement) {
            comment = commentElement.value.trim();
        }
        const optOutElement = document.querySelector("#its-lit-coupon-modal-form #optOut"); // Duplicate ID alert!
        if (optOutElement) {
            comment += `, Do Not Sell Personal Info: ${optOutElement.checked}`;
        }
        return comment;
    }
    _presubmit() {
        const errorElement = document.getElementById(couponErrorElementId);
        errorElement.textContent = "";
        const submitButton = document.querySelector(couponModalSubmitButtonQuery);
        submitButton.setAttribute("disabled", "true");
        const leadSource = document
            .getElementById("its-lit-coupon-campaign-id")
            ?.textContent?.trim();
        if (leadSource) {
            const config = window.fireplaceCouponFormModalConfig;
            dWindow.DealeronLead.thirdPartyJsonAdapter.setData(config.thirdPartyJson);
            dWindow.DealeronLead.thirdPartyJsonAdapter.setData({
                CampaignId: leadSource,
            });
        }
        else {
            console.error("#its-lit-coupon-campaign-id does not exist. Failed to set CampaignId");
        }
    }
    _onSuccess(data) {
        const errorElement = document.getElementById(couponErrorElementId);
        errorElement.textContent = "";
        dWindow.DealeronLead.defaultSuccessCallBack(data);
    }
    _onError() {
        const errorElement = document.getElementById(couponErrorElementId);
        errorElement.textContent =
            dWindow.DealeronLead.errMsg[dWindow.DealeronLead.currentLocale].submissionError;
        const submitButton = document.querySelector(couponModalSubmitButtonQuery);
        submitButton.removeAttribute("disabled");
    }
}
selfInstantiateOnLoad(FireplaceCouponModal);
